<template>
  <div v-if="(user_accesses && userService.hasAccess(user_accesses, ['admin', 'view_client']))">
    <Toast/>
    <div class="card card-theme">
      <Steps :model="items" :readonly="true" style="margin-bottom: 1rem"/>
    </div>
    <keep-alive>
      <router-view :user_accesses="user_accesses" :formData="formObject" @prevPage="prevPage($event)" @nextPage="nextPage($event)"
                   @complete="complete"/>
    </keep-alive>
  </div>
</template>

<script>
  import ClientService from '../../services/ClientService';
  import UserService from '../../services/UserService';

  export default {
    name: 'NewClient',
    props: {
      mode: {
        type: String,
        required: false
      },
      client_id: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        items: [
          {
            label: 'General Info',
            to: '/client/general'
          },
          {
            label: 'Car Parks',
            to: '/client/park'
          },
          {
            label: 'Staff',
            to: '/client/staff'
          }
        ],
        formObject: {},
        user_accesses: this.$store.state.accesses,
        userService: null,
        clientService: null,
      }
    },
    methods: {
      nextPage(event) {
        (event.pageIndex < this.items.length - 1) ? this.$router.push(this.items[event.pageIndex + 1].to).catch() : this.$router.push('/clients').catch()
        // this.$router.push(this.items[event.pageIndex + 1].to).catch();
      },
      prevPage(event) {
        this.$router.push(this.items[event.pageIndex - 1].to).catch();
      },
      complete(event) {
        for (let field in event.formData) {
          this.formObject[field] = event.formData[field];
        }

        let client_info = localStorage.getItem("client_info") ? JSON.parse(localStorage.getItem("client_info")) : null;
        this.formObject.id = client_info ? client_info.id : null;
        this.clientService.setClient(this.formObject).then((result) => {
          if (result.status === 200) {
            localStorage.setItem("client_info", JSON.stringify(result.data.client));
            (event.pageIndex < this.items.length - 1) ? this.$router.push(this.items[event.pageIndex + 1].to).catch() : this.$router.push('/clients').catch()
          } else {
            this.$toast.add({
              severity: 'warn',
              summary: 'Failed to submit',
              detail: result.data.error
            });
          }
        });
      },
    },
    created() {
      this.clientService = new ClientService();
      this.userService = new UserService();
      if (!this.user_accesses){
        let user_info = this.$store.state.user_info ? JSON.parse(this.$store.state.user_info) : {};
        this.userService.getUserAccesses(user_info.id).then(result => {
          if (result.status === 200) {
            let accesses = result.data.accesses;
            this.$store.state.accesses = accesses;
            this.user_accesses = accesses;
          }
        });
      }
    },
    mounted() {
      if (this.$route.path === '/client') {
        localStorage.removeItem("client_info");
        this.$router.push('/client/general').catch();
      }
      else if (this.mode === 'edit' && this.client_id) {
        this.clientService.getClient(this.client_id).then(response => {
          localStorage.setItem("client_info", JSON.stringify(response.data.client));
          this.$router.push('/client/general').catch();
          // setTimeout(function(){ this.$router.push('/client/general').catch(); }, 100);
        });
      }
    }
  }

</script>

<style scoped>

</style>